import { render, staticRenderFns } from "./AssaysTable.vue?vue&type=template&id=60664fea&scoped=true"
import script from "./AssaysTable.vue?vue&type=script&lang=js"
export * from "./AssaysTable.vue?vue&type=script&lang=js"
import style0 from "./AssaysTable.vue?vue&type=style&index=0&id=60664fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60664fea",
  null
  
)

export default component.exports